import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b61b9c76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-bin-new" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "note" }
const _hoisted_9 = ["disabled"]

import { onMounted, ref } from 'vue';
  import { mineBreadcurmbStore } from '@/stores';
  import { useI18n } from 'vue-i18n';
  import { useRoute, useRouter } from 'vue-router';
  import { request } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const binName = ref();
  const route = useRoute();
  const router = useRouter();

  onMounted(() => {
    mineBreadcurmbStore.update([
      { name: t('PDO Dashboard'), to: { name: 'pdo.programs' } },
      { name: String(route.query.title), to: { name: 'pdo.program', params: { id: route.params.id } } },
      { name: t('Create Bin') }
    ]);
  });

  async function handleSubmit() {
    await request.post('/mine/collection_bins', {
      name: binName.value,
      program_id: route.query.programId,
      target_id: route.params.id
    });
    router.back();
  }

return (_ctx: any,_cache: any) => {
  const _component_b_form_input = _resolveComponent("b-form-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('Create Bin')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('offline_collection.record.Bin Name')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_b_form_input, {
            modelValue: binName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((binName).value = $event)),
            placeholder: _unref(t)('offline_collection.record.Bin Name')
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("b", null, _toDisplayString(_unref(t)('note')) + ": ", 1),
        _createTextVNode(_toDisplayString(_unref(t)('note text')), 1)
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary submit-button",
      disabled: !binName.value,
      onClick: handleSubmit
    }, _toDisplayString(_unref(t)('Submit')), 9, _hoisted_9)
  ]))
}
}

})